import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, AlertMessage } from "components/atoms";
import { EmailInput } from "components/molecules";
import { useAuth } from "contexts";

const ResetPasswordSchema = Yup.object().shape({
  username: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
});

const ResetPasswordForm: React.FC = () => {
  const { setAuthState, handleResetPassword } = useAuth();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSuccessfulReset = (username: string): void => {
    resetPasswordFormik.resetForm();
    setAuthState((prevState) => ({
      ...prevState,
      temporaryData: {
        username: username,
      },
    }));
  };

  const handleResetError = (error: unknown): void => {
    const errorMessage = error instanceof Error ? error.message : String(error);
    setErrorMessage(errorMessage);
  };

  const handleResetPasswordSubmit = async (values: { username: string }) => {
    try {
      const error = await handleResetPassword(values.username);

      if (error) {
        handleResetError(error);
        return;
      }

      handleSuccessfulReset(values.username);
    } catch (error) {
      handleResetError(error);
    }
  };

  const resetPasswordFormik = useFormik({
    initialValues: {
      username: "",
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: handleResetPasswordSubmit,
  });

  const toSignIn = (): void => {
    setAuthState((prevState) => ({
      ...prevState,
      nextStep: "SIGN_IN",
    }));
  };

  return (
    <form className="auth-form" onSubmit={resetPasswordFormik.handleSubmit}>
      <div className="form-group">
        <h2>Reset Password</h2>
      </div>

      <EmailInput
        id="username"
        label="Enter your email"
        getFieldProps={resetPasswordFormik.getFieldProps}
        touched={resetPasswordFormik.touched.username}
        error={resetPasswordFormik.errors.username}
      />

      {errorMessage && <AlertMessage type="error">{errorMessage}</AlertMessage>}

      <Button
        type="submit"
        text="Send Code"
        className="form-button"
        width="100%"
        variant="primary"
      />

      <Button
        type="button"
        text="Back to Sign In"
        onClick={toSignIn}
        className="form-button"
        width="100%"
        variant="border"
      />
    </form>
  );
};

export default ResetPasswordForm;
